/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Typography } from "@mui/material";

const textColor = '#323232'

export const StyledTitle = styled(Typography)({
  mb: 2,
  fontWeight: 600,
  color: textColor,
  fontSize: '20px',
})

export const StyledDescription = styled(Typography)({
  mb: 3,
  lineHeight: 1.6,
  mt: 2
})

export const StyledConfirmation = styled(Typography)({
  lineHeight: 2.7
})

export const OptionLabel = styled(Typography)({
  fontWeight: '500',
  color: textColor,
})

export const OptionDescription = styled(Typography)({
  display: 'block',
  lineHeight: 1.4,
})

export const StyledEnforceTitle = styled(Typography)({
   mb: 2,
   fontWeight: 600,
   color: textColor
})
